import { ResponsiveImage } from '../ResponsiveImage';

interface HeroProps {
  title?: string;
  subtitle?: string;
  backgroundUrl?: string;
  backgroundUrlSrcset?: string;
  backgroundUrlWebpSrcset?: string;
  backgroundUrlBlurDataUrl?: string;
  ctaText?: string;
  ctaLink?: string;
  overlayOpacity?: number;
}

export function HeroBlock({ props }: { props: HeroProps }) {
  const opacity = props.overlayOpacity ?? 0.4;
  return (
    <div
      className="relative w-full min-h-[400px] sm:min-h-[480px] flex items-center justify-center text-white overflow-hidden"
      style={{
        backgroundColor: props.backgroundUrl ? undefined : 'var(--color-primary)',
        viewTransitionName: 'site-hero',
      }}
    >
      {props.backgroundUrl && (
        <ResponsiveImage
          src={props.backgroundUrl}
          srcset={props.backgroundUrlSrcset}
          webpSrcset={props.backgroundUrlWebpSrcset}
          blurDataUrl={props.backgroundUrlBlurDataUrl}
          sizes="100vw"
          loading="eager"
          className="absolute inset-0 w-full h-full object-cover"
        />
      )}
      <div
        className="absolute inset-0"
        style={{ backgroundColor: `rgba(0,0,0,${opacity})` }}
      />
      <div className="relative z-10 text-center px-6 py-16 max-w-3xl mx-auto">
        {props.title && (
          <h1 className="text-3xl sm:text-5xl font-bold leading-tight mb-4">{props.title}</h1>
        )}
        {props.subtitle && (
          <p className="text-base sm:text-xl text-white/80 mb-8">{props.subtitle}</p>
        )}
        {props.ctaText && props.ctaLink && (
          <a
            href={props.ctaLink}
            className="inline-block px-8 py-3 rounded-xl bg-white text-zinc-900 font-semibold text-sm hover:bg-zinc-100 transition-colors shadow-md"
          >
            {props.ctaText}
          </a>
        )}
      </div>
    </div>
  );
}
